module.exports = __webpack_public_path__ + "img/video-title-ja.d53196a1.png";